<template lang="pug">
  tabs.search-results-tabs(@changed="tabChanged")
    tab(title="PRODUCTS")
    tab(title="ARTICLES")
    tab(title="PAGES")
</template>

<script>
import { Tabs, Tab } from 'vue-simple-tabs'

export default {
  name: 'SearchResultsTabs',
  components: { Tabs, Tab },
  methods: {
    tabChanged (tab) {
      this.$emit('change-tab', tab.title.toLowerCase())
    }
  }
}
</script>

<style lang="scss" scoped>
  .search-results-tabs {
    height: 100px;
    width: 100%;
    border-bottom: 1px solid $color-light-grey;

    @include mobile-only {
      height: 60px;
    }

    /deep/ ul {
      display: flex;
      justify-content: center;
      padding: 0;
      margin: 0;
    }
    /deep/ li {
      cursor: pointer;
      position: relative;
      font-family: $font-family-secondary;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 1px;
      line-height: 15px;
      text-align: center;
      display: flex;
      align-items: flex-end;
      height: 80px;
      padding: 16px 8px;
      margin: 0 12px;
      color: $color-grey;

      @include mobile-only {
        height: 60px;
      }

      &::after {
        content: ' ';
        position: absolute;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: transparent;
        transform: scaleY(0) translateY(4px);
        transition: transform 300ms ease, background-color 300ms ease;
      }
      &.active {
        color: $color-black;
        &::after {
          transform: scaleY(1) translateY(4px);
          background-color: $color-brand-primary;
        }
      }
    }
  }
</style>
